import { useEffect } from 'react';

import { useRequestCancel } from 'hooks/common/useRequestCancel';

import { fetchCampaigns } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/fetchCampaigns';
import { fetchCampaignsCount } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/fetchCampaignsCount';

import {
    AppliedCampaignsFilters,
    setAppliedCampaignsFilters,
    setAppliedCampaignsFiltersTotalCount,
} from 'store/models/campaignsFilters';
import { useDispatch } from 'store/utils';

interface ApplyCampaignsFiltersArgs {
    filters?: AppliedCampaignsFilters;
    searchValue?: string;
    count?: number;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

type ApplyCampaignsFilters = (args: ApplyCampaignsFiltersArgs) => void;

export const useApplyCampaignsFilters = (): {
    applyCampaignsFilters: ApplyCampaignsFilters;
    abortRequest: () => void;
} => {
    const dispatch = useDispatch();
    const { abortRequest, abortSignal } = useRequestCancel();

    useEffect(() => {
        return () => {
            abortRequest();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const applyCampaignsFilters = ({ filters, searchValue, count, onSuccess, onError }: ApplyCampaignsFiltersArgs) => {
        abortRequest();
        const signal = abortSignal();

        void dispatch(fetchCampaignsCount({ abortSignal: signal, filters, searchValue }));
        void dispatch(fetchCampaigns({ abortSignal: signal, filters, searchValue }))
            .then(() => {
                if (!signal.aborted) onSuccess?.();
            })
            .catch((error) => {
                if (!signal.aborted) onError?.(error);
            });

        dispatch([
            ...(filters !== undefined ? [setAppliedCampaignsFilters({ ...filters })] : []),
            ...(count !== undefined ? [setAppliedCampaignsFiltersTotalCount(count)] : []),
        ]);
    };
    return { applyCampaignsFilters, abortRequest };
};
